function _hash(r) {
  var t,
      n = 0;
  if (0 === r.length) return n;

  for (t = 0; t < r.length; t++) {
    n = (n << 5) - n + r.charCodeAt(t), n |= 0;
  }

  return n;
}

function hashRandom() {
  return _hash(new Date().getTime() + "_" + Math.random());
}

function hashString(r) {
  return _hash(r);
}

function hashObject(r) {
  return _hash("object" == typeof r ? JSON.stringify(r) : "");
}

function hashArray(r) {
  return _hash("object" == typeof r && Array.isArray(r) ? JSON.stringify(r) : "");
}

module.exports = {
  hashRandom: hashRandom,
  hashString: hashString,
  hashObject: hashObject,
  hashArray: hashArray
};